import { Link } from "react-router-dom";
import Reveal from "@/components/landing/Reveal";
import { assetUrl } from "@/lib/assetUrl";

/**
 * Reusable product card. Renders any product object from the API.
 * Links to /diwali-collection/:slug automatically.
 */
export default function ProductCard({ product, index = 0 }) {
  const bulkPrice = `₹${product.price.toLocaleString("en-IN")}`;
  const mrpFormatted =
    product.mrp && Number(product.mrp) > 0
      ? `₹${Number(product.mrp).toLocaleString("en-IN")}`
      : null;
  // Card thumbnails render around 300-500px wide; request 640 for retina.
  const img = assetUrl(product.images && product.images[0], 640);
  return (
    <Reveal delay={index > 3 ? 3 : index} className="dc-card" data-testid={`product-card-${product.slug}`}>
      <Link to={`/diwali-collection/${product.slug}`} className="dc-card-link" aria-label={`View ${product.name}`}>
        <div className="dc-card-media">
          {product.badge && <span className="dc-card-badge" data-testid={`product-badge-${product.slug}`}>{product.badge}</span>}
          {img ? (
            <img src={img} alt={product.name} loading="lazy" decoding="async" />
          ) : (
            <div className="dc-card-placeholder">
              <svg width="44" height="44" viewBox="0 0 64 64" fill="none" aria-hidden>
                <rect x="8" y="16" width="48" height="36" rx="3" fill="var(--u-orange)" opacity="0.24" />
                <rect x="14" y="10" width="36" height="8" rx="2" fill="var(--u-orange)" opacity="0.2" />
              </svg>
              <div className="dc-card-placeholder-label">{product.name}</div>
            </div>
          )}
        </div>
        <div className="dc-card-body">
          <div>
            <h3 className="dc-card-title">{product.name}</h3>
            <div className="dc-card-price" data-testid={`product-card-price-${product.slug}`}>
              <span className="dc-card-price-label">Bulk Price</span>
              <span className="dc-card-price-value">{bulkPrice}</span>
              {mrpFormatted ? (
                <span className="dc-card-price-mrp" data-testid={`product-card-mrp-${product.slug}`}>
                  MRP <s>{mrpFormatted}</s>
                </span>
              ) : null}
            </div>
          </div>
          <span className="dc-card-cta">
            View Hamper
            <svg width="14" height="10" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </Link>
    </Reveal>
  );
}
